import https from "../../configs/axios.config";
import { API_ROUTES } from "../../constants/API_ROUTES";

export const assetService = {
  getOriginalProfiles: async (token, params = {}) => {
    const query = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        query.set(key, String(value));
      }
    });

    const url = query.toString()
      ? `${API_ROUTES.FILE.GET_ORIGINAL}?${query.toString()}`
      : API_ROUTES.FILE.GET_ORIGINAL;

    const response = await https.get(url, {
      headers: { Authorization: `Bearer ${token}` },
    });

    return response;
  },
  getOriginalProfileReport: async (token, params = {}) => {
    const response = await https.get(
      API_ROUTES.REPORT.GET_REPORT_CLIENT_PROFILE_ORIGINAL,
      {
        headers: { Authorization: `Bearer ${token}` },
        params,
      },
    );

    return response;
  },
  exportOriginalProfilesPdf: async (token, params = {}) => {
    const response = await https.get(
      API_ROUTES.REPORT.EXPORT_ORIGINAL_PROFILE_PDF,
      {
        headers: { Authorization: `Bearer ${token}` },
        params,
        responseType: "blob",
      },
    );

    return response;
  },
};